module.exports = __webpack_public_path__ + "Roboto-BoldItalic.d23d5bdadc495f12ef69.ttf";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-BoldItalic.ttf
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-BoldItalic.ttf
// module chunks = 16